
import Screen from ".."
import Loader from "../../Loader"

const LoadingScreen = () => (
    <Screen>
        <Loader loading />
    </Screen>
)

export default LoadingScreen